export default (obj: object, key: any): boolean => obj.hasOwnProperty(key);
